import { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Hakkımızda', href: '#about' },
    { name: 'Çözümler', href: '#solutions' },
    { name: 'Neden WOTECH', href: '#why' },
    { name: 'Referanslar', href: '#testimonials' },
    { name: 'İletişim', href: '#contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white border-b border-[#E2E8F0]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-18 py-4">
          <a href="#" className="flex items-center gap-2.5 cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#0891B2]">
              <i className="ri-cpu-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-extrabold text-[#0F172A] font-heading tracking-tight">
              WO<span className="text-[#0891B2]">TECH</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item, i) => (
              <a key={i} href={item.href} className="text-[#475569] hover:text-[#0F172A] transition-colors text-sm font-medium font-body cursor-pointer relative group">
                {item.name}
                <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-[#0891B2] transition-all duration-300 group-hover:w-full rounded-full" />
              </a>
            ))}
            <a href="#contact" className="px-5 py-2.5 bg-[#0891B2] text-white text-sm font-semibold rounded-lg hover:bg-[#0E7490] transition-all duration-200 whitespace-nowrap cursor-pointer font-body">
              Demo Talep Et
            </a>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-[#475569] cursor-pointer" aria-label="Menü">
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden pb-5 border-t border-[#E2E8F0] bg-white">
            <div className="flex flex-col gap-1 pt-4">
              {navItems.map((item, i) => (
                <a key={i} href={item.href} onClick={() => setIsMobileMenuOpen(false)} className="px-2 py-2.5 text-sm font-medium text-[#475569] hover:text-[#0F172A] cursor-pointer font-body">
                  {item.name}
                </a>
              ))}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-2 px-5 py-3 bg-[#0891B2] text-white text-sm font-semibold rounded-lg text-center whitespace-nowrap cursor-pointer font-body">
                Demo Talep Et
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
